const combineDateTime = (selectedDate: Date, selectedTime: Date): string => {
  const datePart = selectedDate.toISOString().split("T")[0];

  const timePart = selectedTime.toTimeString().split(" ")[0];

  return `${datePart}T${timePart}`;
};

export default combineDateTime;
